var t=Function.call.bind(Object.prototype.hasOwnProperty);export{t as default};
//# sourceMappingURL=has.js.map
